module.exports = __webpack_public_path__ + "img/7.2160bc08.png";